<template>
  <div class="size-full relative">
    <b-skeleton-img
      v-if="loading && displayImages.length === 0"
      class="size-full"
      height="285px"
    />
    <LazySwiper
      v-else-if="imageList.length"
      class="size-full"
      v-bind="sliderOptions"
      arrows-color="white"
      :loading-skeleton-aspect="false"
      @slide-change="handleSlideChange"
    >
      <LazyResponsiveHotelImage
        v-for="(image, index) in imageList"
        :key="`image_new_${index}`"
        class="carousel-image"
        :image="image"
        :alt="`${package?.hotel} ${index}`"
        preferred-size="max"
        fit="cover"
      />
    </LazySwiper>
  </div>
</template>

<script>
export default defineNuxtComponent({
  setup () {
    const { public: { images: imagesConfig } } = useRuntimeConfig()

    return {
      imagesConfig,
    }
  },

  name: 'HeaderImageCarousel',

  props: {
    package: {
      type: Object,
      required: true,
    },

    displayImages: {
      type: Array,
      default: () => [],
    },

    loading: {
      type: Boolean,
      default: false,
    },

    maxSlides: {
      type: Number,
      default: 5,
    },

    nested: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['slideChange'],
  /* eslint-disable @typescript-eslint/no-unused-vars, no-unused-vars */
  data () {
    const {
      maxSlides,
      loading,
      displayImages,
      package: p,
      ...swiperOptions
    } = this.$props

    return {
      sliderOptions: {
        ...swiperOptions,
        pagination: true,
        navigation: true,
        loop: true,
        onlyRenderVisibleSlides: true,
        preventSwiperUpdate: true,
        dotsAlign: 'bottom',
        arrowsAlign: 'inside',
      },
    }
  },

  computed: {
    imageList () {
      if ((this.displayImages || []).length === 0) {
        return [this.imagesConfig.fallbackImage]
      }
      return this.displayImages.slice(0, this.maxSlides)
    },
  },

  methods: {
    handleSlideChange (newSlideIndex) {
      this.$emit('slideChange', newSlideIndex)
    },
  },

})
</script>
